const MAX_SIDE = 1600;
const PASS_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

const decode = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("decode"));
    img.src = url;
  });

// Приводит фото к JPEG ≤1600px (HEIC, огромные фото с телефона и т.п.)
export async function normalizeImage(file) {
  if (file.type === "image/gif") return file;
  let img;
  try {
    img = await decode(file);
  } catch {
    throw new Error(`«${file.name}»: формат не поддерживается — сохраните как JPG или PNG`);
  }
  const w = img.naturalWidth, h = img.naturalHeight;
  const small = Math.max(w, h) <= MAX_SIDE && file.size <= 2 * 1024 * 1024;
  if (small && PASS_TYPES.includes(file.type)) return file;
  const k = Math.min(1, MAX_SIDE / Math.max(w, h));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(w * k);
  canvas.height = Math.round(h * k);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.88));
  if (!blob) throw new Error(`«${file.name}»: не удалось обработать изображение`);
  return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
}
